import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type ModifierLabelProps = {
  label: string;
  layoutClassName?: string;
  UNSAFE_className?: string;
};

const ModifierLabel: React.FC<ModifierLabelProps> = ({
  label,
  layoutClassName,
  UNSAFE_className,
}) => {
  return (
    // NOTE (Sebas, 2024-10-01): This `flex` is necessary to make the label take
    // up the full width of its container. Adding it to the next div element does
    // not work.
    <div className="flex">
      <div
        className={twMerge(
          "text-muted flex w-[74px] select-none whitespace-nowrap text-xs",
          layoutClassName,
          UNSAFE_className,
        )}
      >
        {label}
      </div>
    </div>
  );
};

export default ModifierLabel;
